import React from "react";
import {CodeSpecNum} from "../../../../../constant/CodeSpecNum";
import SimmsInputSearch from "../../../../../components/input/SimmsInputSearch";
import SimmsDrawerSearch from "../../../../../components/drawer/simms/SimmsDrawerSearch";

/** SearchSelector 자산목록 공통 필터 (계약·구매·리스·실사 등) */
export function AssetSearchFilters({platFrom, placeHolder = "자산명", diligenceId}) {
    return (
        <>
            <SimmsInputSearch type="TEXT" placeHolder={placeHolder} />
            {diligenceId != null && (
                <SimmsInputSearch type="HIDDEN" value={diligenceId} />
            )}
            <SimmsDrawerSearch
                showLabel
                title="자산그룹"
                entity="code"
                target="group"
                parentKey={CodeSpecNum.AssetGroupCode}
                uniqueKey="group"
                recursive
            />
            <SimmsDrawerSearch
                showLabel
                title="업무그룹"
                entity="code"
                target="task"
                parentKey={CodeSpecNum.TaskGroupCode}
                uniqueKey="task"
                recursive
            />
            <SimmsDrawerSearch
                showLabel
                title="자산위치"
                entity="code"
                target="location"
                parentKey={CodeSpecNum.AssetLocation}
                uniqueKey="location"
                recursive
            />
            {platFrom === "ITM" && (
                <SimmsDrawerSearch
                    showLabel
                    title="SLA 그룹"
                    entity="code"
                    target="slaGroup"
                    parentKey={CodeSpecNum.SlaGroupCode}
                    uniqueKey="slaGroup"
                    recursive
                />
            )}
            <SimmsDrawerSearch showLabel title="운영담당자" entity="userAccount" target="operator" />
            <SimmsDrawerSearch showLabel title="자산사용자" entity="userAccount" target="handler" />
        </>
    );
}
